import React, { useEffect, useState } from 'react'
import { Card, Avatar, Button, Progress, Typography, Popconfirm } from 'antd'
import styled from 'styled-components'
import { CompetitionService, DateUtility } from 'utility'
import { CommonPagination, FlexRow, UserAvatarWithName } from 'components'
import { House, Hash, ThumbsUp, Trash } from 'phosphor-react'
import { useNavigate } from 'react-router-dom'

const { Text } = Typography

//   align-items: center;
//   gap: 12px;
// `

// const IconGroup = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 8px;
//   color: #3b82f6;
//
const CompletedButton = styled(Button)`
  background: #b3b3b3;
  color: rgb(232, 232, 232);
`

const LiveButton = styled(Button)`
  background: #fafafa;
  border: 1px solid #ddd;
  color: #00c82a;

  &:hover {
    background: #4b54b2;
    border-color: #4b54b2;
    color: #fff;
  }
`

const UpcomingButton = styled(Button)`
  background: #fafafa;
  color: #1a1a1a;
`
const Wrapper = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  width: 100%;
`
const IconGroup = styled.div`
  color: #2454ff;

  span {
    color: #1a1a1a;
  }
`

const RemoveButton = styled.button`
  background: #fee2e2;
  color: #dc2626;
  border: none;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background: #fecaca;
  }
`

const WinnerText = styled(Text)`
  font-weight: 500;
  color: 767676;
  margin-right: 5px;
`

const WarnText = styled(Text)`
  font-weight: 500;
  color: #ff4d4f;
  margin-right: 5px;
`

const GreenText = styled(Text)`
  font-weight: 500;
  color: #52c41a;
  margin-right: 5px;
`
const StatusButton = styled(Button)`
  border: 1px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};
`
// const getBorder = props => {
//   if (props.isUpcoming) return '2px solid  #F3E7CE'
//   // if (props.isLive) return '2px solid #5C67CA'
//   if (props.isCompleted) return '2px solid #E0E0E0'

//   return '1px solid #2454ff'
// }

const StyledCard = styled(Card)`
  background: ${({ theme }) => theme.colors.background};
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 6.33px 6.33px 50.94px 0px #0000000d;
  border: 1px solid #ededed;
  .ant-card-body {
    padding: 10px 16px;
  }
`
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const CompetitionInfo = styled.div`
  display: flex;
  align-items: start;
  gap: 12px;
`
const CompetitionDetails = styled.div`
  // margin-left: 12px;
`
const ProgressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 10px 0;
`
const Round = styled.div`
  font-size: 16px;
  text-align: left;
  font-family: var(--font-secondary);
  color: #1a1a1a;

  font-weight: normal;
  margin-bottom: 5px;
`

const ProgressContainer = styled.div`
  width: 100%;
  position: relative;
  height: 20px;
`

const RankBox = styled.div`
  flex-direction: column;
  display: flex;
  align-items: flex-start;
  padding: 10px;
  background: #faf7ea;
  border: 1px solid #d4af37;
  border-radius: 8px;
  margin-top: 10px;
`
const RoundInfo = styled.div`
  text-align: left;
  margin-top: 12px;

  h5 {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 5px;
  }
  h6 {
    margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #1a1a1a;
    span {
      font-weight: bold;
      color: #1a1a1a;
    }
  }
`

export const CompetitionProgress = ({
  totalRounds,
  currentRoundIndex,
  competitionStatus,
}) => {
  const progressPercent = (currentRoundIndex / totalRounds) * 100
  const progressColors = {
    live: {
      strokeColor: '#1a1a1a',
      trailColor: '#767676',
    },
    completed: {
      strokeColor: '#767676',
      trailColor: '#767676',
    },
    upcoming: {
      strokeColor: '#CECECE',
      // trailColor: '#F7F0DE',
    },
  }

  const { strokeColor, trailColor } = progressColors[competitionStatus] || {
    strokeColor: '#1a1a1a',
    trailColor: '#e5e7eb',
  }
  return (
    <ProgressWrapper>
      <Round isCompleted={currentRoundIndex <= totalRounds}>
        Round {currentRoundIndex}/{totalRounds}
      </Round>
      <ProgressContainer>
        <Progress
          percent={progressPercent}
          strokeColor={strokeColor}
          trailColor={trailColor}
          showInfo={false}
          strokeWidth={4}
        />
      </ProgressContainer>
    </ProgressWrapper>
  )
}

export const StatusBox = ({ competition }) => {
  // const competitionStatus = useMemo(() => {
  //   if (
  //     DateUtility.isPast(lastRound?.result_announcement) ||
  //     DateUtility.isPast(competition?.end_date)
  //   ) {
  //     return 'completed'
  //   }
  //   if (
  //     (!DateUtility.isPast(lastRound?.result_announcement) ||
  //       !DateUtility.isPast(competition?.end_date)) &&
  //     (DateUtility.isPast(currentRound?.start_date) ||
  //       DateUtility.isPast(competition?.start_date))
  //   ) {
  //     return 'live'
  //   }
  //   if (!DateUtility.isPast(lastRound?.start_date)) {
  //     return 'upcoming'
  //   }

  //   return 'live'
  // }, [competition, lastRound, currentRound])

  return (
    <>
      {competition === 'completed' && (
        <CompletedButton type="default" disabled>
          Completed
        </CompletedButton>
      )}
      {competition === 'live' && (
        <LiveButton active type="default">
          Live
        </LiveButton>
      )}
      {competition === 'upcoming' && (
        <UpcomingButton type="default">Upcoming</UpcomingButton>
      )}
    </>
  )
}

export const CompetitionCard = ({
  competition,
  // showRankBox = true,
  onDelete,
  showStats,
}) => {
  const eventData = competition
  const currentDate = new Date()
  const rounds = eventData.rounds.sort(
    (a, b) => a.round_number - b.round_number,
  )
  const totalRounds = rounds.length
  const latestResultRound = [...rounds]
    .filter(round => new Date(round.result_announcement) <= currentDate)
    .sort(
      (a, b) =>
        new Date(b.result_announcement) - new Date(a.result_announcement),
    )[0]

  const nextRound = rounds.find(
    round => new Date(round.start_date) > currentDate,
  )
  const nextRoundStart =
    nextRound?.round_number <= totalRounds && nextRound.name
  const getRoundStatus = () => {
    const roundNumber = Number(latestResultRound?.round_number)
    if (roundNumber < 1) {
      return `Round ${roundNumber} Result Announced`
    }
    if (roundNumber === totalRounds) {
      return 'Completed'
    }
    return 'No Result Announced'
  }
  return (
    <StyledCard
      isUpcoming={competition?.status === 'upcoming'}
      isLive={competition?.status === 'live'}
      isCompleted={competition?.status === 'completed'}
    >
      <Header>
        <CompetitionInfo>
          <Avatar size={48} src={competition?.image} />
          <CompetitionDetails>
            <Text strong>{competition?.name}</Text>
          </CompetitionDetails>
        </CompetitionInfo>
        <FlexRow>
          <StatusBox competition={competition?.status} />
          {
            onDelete &&
            <Popconfirm
              title="Are you sure you want to delete this competition?"
              onConfirm={e => {
                e?.stopPropagation()
                onDelete(competition?._id)
              }}
              onCancel={e => e?.stopPropagation()}
              okText="Yes"
              cancelText="No"
            >
              <RemoveButton onClick={e => e.stopPropagation()} className="ms-3">
                <Trash size={16} color="#dc2626" weight="bold" />
              </RemoveButton>
            </Popconfirm>
          }
        </FlexRow>
      </Header>

      <CompetitionProgress
        totalRounds={totalRounds}
        currentRoundIndex={latestResultRound?.round_number || 1}
        competitionStatus={competition?.status}
      />

      <RoundInfo>
        <h5>{getRoundStatus()}</h5>
        {(competition?.status !== "upcoming" && !latestResultRound?.winnerSelected) && (
          <>
            {
              latestResultRound?.round_number ?
                <WarnText>
                  Select Winner for round {latestResultRound?.round_number} before{' '}
                  <span>{DateUtility.startsInOnly(nextRound?.start_date || competition?.end_date)}</span>
                </WarnText>
                :
                <>
                  {
                    competition?.winners?.length === 0 &&
                    <WarnText>
                      Select Winner for round 1 before{' '}
                      <span>{DateUtility.startsInOnly(nextRound?.start_date || competition?.end_date)}</span>
                    </WarnText>
                  }
                </>
            }
          </>
        )}
        {latestResultRound?.winnerSelected &&
          latestResultRound?.round_number !== totalRounds && (
            <GreenText>
              Winner Selected for round {latestResultRound?.round_number}
            </GreenText>
          )}
        {latestResultRound?.round_number !== totalRounds && (
          <h6>
            {nextRoundStart}{' '}
            <span>{DateUtility.startsIn(nextRound?.start_date)}</span>
          </h6>
        )}
      </RoundInfo>

      {competition?.winners?.length > 0 && (
        <RankBox>
          <div>
            <small className="fw-bold">Winners :</small>
          </div>
          {competition?.winners?.map((ele, winnerIndex) => (
            <div className="my-1" key={ele?.fid || winnerIndex}>
              <FlexRow>
                <WinnerText strong> </WinnerText>
                <UserAvatarWithName
                  id={ele?.fid}
                  title={ele?.name}
                  url={ele?.image}
                />
              </FlexRow>
            </div>
          ))}
        </RankBox>
      )}

      {showStats && (
        <Wrapper className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-3">
            <IconGroup>
              <span>Rank #1</span>
              <div className="d-flex align-items-center gap-2">
                <House size={18} weight="bold" color="#2454ff" />
                <Hash size={18} weight="bold" color="#2454ff" />
                --
              </div>
            </IconGroup>

            <IconGroup>
              <span>Total votes received:</span>
              <div className="d-flex align-items-center gap-2">
                --
                <ThumbsUp size={18} weight="bold" color="#2454ff" />
              </div>
            </IconGroup>
          </div>
        </Wrapper>
      )}
    </StyledCard>
  )
}

export const CompetitionList = ({
  list,
  page,
  pageChanged,
  total,
  onDetail,
  setList,
}) => {
  const [localTotal, setLocalTotal] = useState(total)

  useEffect(() => {
    setLocalTotal(total)
  }, [total])

  const onDelete = async id => {
    try {
      await CompetitionService.remove(id)
      setList(prev => prev.filter(item => item._id !== id))
      setLocalTotal(prev => prev - 1) // Decrease local total
    } catch (error) {
      console.error('Error deleting competition:', error)
    }
  }

  return (
    <div className="col-12">
      {list.map(item => (
        <div className="mb-4" key={item._id} onClick={() => onDetail(item._id)}>
          <CompetitionCard onDelete={onDelete} competition={item} />
        </div>
      ))}
      <FlexRow className="justify-content-end">
        <CommonPagination
          page={page}
          pageChanged={pageChanged}
          total={localTotal}
        />
      </FlexRow>
    </div>
  )
}

const RoundBox = ({ competitionId, competitionName, round }) => {
  const navigate = useNavigate()
  return (
    <StyledCard
      onClick={() =>
        navigate(
          `/app/competitions/${competitionId}/rounds/${round?.round_number}`,
          {
            state: {
              competitionName,
            },
          },
        )
      }
      isUpcoming={round.status === 'upcoming'}
      isLive={round.status === 'live'}
      isCompleted={round.status === 'completed'}
    >
      <Header>
        <CompetitionInfo>
          <CompetitionDetails>
            <Text strong>{round.name}</Text>
          </CompetitionDetails>
        </CompetitionInfo>
        {round.status === 'completed' && (
          <Button type="default" disabled>
            Completed
          </Button>
        )}
        {round.status === 'live' && (
          <StatusButton active type="default">
            Live
          </StatusButton>
        )}
        {round.status === 'upcoming' && (
          <StatusButton type="default">Upcoming</StatusButton>
        )}
      </Header>
      {round.status === 'live' && (
        <>
          <FlexRow className="deadline-row">
            <p>Submission deadline: </p>
            <h6>
              {DateUtility.formatDate(new Date(round.submission_deadline))}
            </h6>
          </FlexRow>
          <FlexRow className="deadline-row">
            <p>Voting deadline: </p>
            <h6>{DateUtility.formatDate(new Date(round.voting_deadline))}</h6>
          </FlexRow>
          <FlexRow className="deadline-row">
            <p>Result Announcement: </p>
            <h6>
              {DateUtility.formatDate(new Date(round.result_announcement))}
            </h6>
          </FlexRow>
        </>
      )}
      {round?.status === 'upcoming' && (
        <FlexRow className="deadline-row">
          <p>Round starts On: </p>
          <h6>{DateUtility.formatDate(new Date(round.start_date))}</h6>
        </FlexRow>
      )}
      {round.status === 'completed' && (
        <>
          <FlexRow className="deadline-row">
            <p>Result Announced On: </p>
            <h6>
              {DateUtility.formatDate(new Date(round.result_announcement))}
            </h6>
          </FlexRow>
          {/* <RankBox>
        <div>
          <small className="fw-bold">Winner:</small>
        </div>
        <div>
          <WinnerText strong>#1</WinnerText>
          <Avatar
            style={{ marginLeft: 30 }}
            size={32}
            src="https://via.placeholder.com/32"
          />
          <WinnerText strong style={{ marginLeft: 8 }}>
            Trapster X
          </WinnerText>
        </div>
      </RankBox> */}
        </>
      )}
    </StyledCard>
  )
}

export const RoundBoxList = ({ competitionName, competitionId, list = [] }) => {
  return (
    <div>
      {list.map(round => (
        <RoundBox
          competitionId={competitionId}
          competitionName={competitionName}
          round={round}
        />
      ))}
    </div>
  )
}
